module.exports = "<h1 mat-dialog-title>Welcome user</h1>\r\n<div mat-dialog-content>\r\n  <p>What's your favorite animal?</p>\r\n \r\n</div>\r\n"